/* istanbul ignore file */
import React, { FC } from 'react'
import { Checkbox, FormControlLabel } from '@moonpig/launchpad-forms'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { Flex, Text } from '@moonpig/launchpad-components'
import { StyledLabel } from './StyledLabel'
import { Filter } from '../../../../services/types/services'

const StyledFilterOption = styled(FormControlLabel)<{ indentation?: number }>`
  display: flex;
  align-items: center;
  width: 100%;

  ${({ indentation }) =>
    s({
      pl: indentation || 4,
      pr: 6,
      py: 3,
      height: '44px',
      color: 'colorTextLabel',
    })}

  & span {
    width: 100%;
  }

  &:hover {
    ${s({
      bgcolor: 'colorBackground02',
    })}
  }

  &:active {
    ${s({
      bgcolor: 'colorBackground03',
    })}
  }

  &:focus,
  &:focus-visible {
    ${s({
      bgcolor: 'colorBackground02',
      color: 'colorInteractionFocusIndicator',
    })}
  }
`

const StyledText = styled(Text)`
  ${s({
    flex: '1',
    typography: 'typeBodyCaption',
    color: 'colorBlack40',
    textAlign: 'right',
  })}
`

type Props = {
  filter: Filter
  indentation?: number
  onClick: (filter: Filter, select: boolean) => void
}

export const FilterOption: FC<Props> = ({ filter, indentation, onClick }) => {
  const { id, label, isSelected, count } = filter

  return (
    <StyledFilterOption
      data-testid="filter-option"
      key={id}
      indentation={indentation}
      label={
        <Flex justifyContent="space-between" alignItems="center" width="100%">
          <StyledLabel label={label} isSelected={!!isSelected} />
          {count ? (
            <StyledText>
              <span>{count}</span>
            </StyledText>
          ) : null}
        </Flex>
      }
    >
      <Checkbox
        onChange={() => onClick(filter, !isSelected)}
        checked={!!isSelected}
        value={id}
      />
    </StyledFilterOption>
  )
}
